import React from 'react';
import { motion } from 'framer-motion';

const KBLogo = ({ size = 64, animate = false }) => {
  const logoVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { duration: 0.5 }
    }
  };

  const glowVariants = {
    animate: {
      filter: [
        'drop-shadow(0 0 8px rgba(80, 200, 120, 0.4))',
        'drop-shadow(0 0 16px rgba(80, 200, 120, 0.7))',
        'drop-shadow(0 0 8px rgba(80, 200, 120, 0.4))',
      ],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }
  };

  const Wrapper = animate ? motion.div : 'div';
  const wrapperProps = animate ? {
    variants: logoVariants,
    initial: "hidden",
    animate: "visible"
  } : {};

  return (
    <Wrapper {...wrapperProps}>
      <motion.div
        className="relative inline-flex items-center justify-center"
        style={{ width: size, height: size }}
        variants={animate ? glowVariants : {}}
        animate={animate ? "animate" : ""}
      >
        <svg
          viewBox="0 0 80 80"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="kbGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#50C878" />
              <stop offset="100%" stopColor="#2E8B57" />
            </linearGradient>
            <filter id="kbGlow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* K with long tail */}
          <g filter="url(#kbGlow)">
            {/* K vertical stroke */}
            <path 
              d="M15 10 L15 70 Q15 78 25 75 L60 60" 
              stroke="url(#kbGrad)" 
              strokeWidth="6" 
              strokeLinecap="round"
              fill="none"
            />
            {/* K upper diagonal */}
            <path 
              d="M15 40 L40 15" 
              stroke="url(#kbGrad)" 
              strokeWidth="6" 
              strokeLinecap="round"
              fill="none"
            />
            {/* K lower diagonal */}
            <path 
              d="M15 40 L40 65" 
              stroke="url(#kbGrad)" 
              strokeWidth="6" 
              strokeLinecap="round"
              fill="none"
            />
            
            {/* B overlapping on top right */}
            <path 
              d="M45 12 L45 42 M45 12 Q65 12 65 22 Q65 32 45 27 M45 27 Q68 27 68 37 Q68 47 45 42" 
              stroke="url(#kbGrad)" 
              strokeWidth="5" 
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </g>
        </svg>
      </motion.div>
    </Wrapper>
  );
};

export default KBLogo;
